module.exports = __webpack_public_path__ + "img/1543155983.2ea4fe6c.jpg";